import $ from 'jquery';
import '../class/wNumb';
import noUiSlider from '../class/nouislider';


const multislider = ($target) => {

	$target.find('.multislider').each(function(){
		var $this = $(this),
			$from = $this.find('.from'),
			$to = $this.find('.to'),
			$fromText = $this.find('.from-text span'),
			$toText = $this.find('.to-text span'),
			slider = $this.find('.slider').get(0);

		noUiSlider
			.create(slider, {
				start: [ $from.val(), $to.val() ],
				step: 10,
				connect: true,
				range: {
					'min': $this.data('min'),
					'max': $this.data('max')
				},
				format: wNumb({
					decimals: 0
				})
			});

		slider.noUiSlider.on('set', function(values) {
			$from.val(values[0]);
			$to.val(values[1]);
			$fromText.text(values[0]);
			$toText.text(values[1]);
			$to.trigger('change');
		});

		slider.noUiSlider.on('slide', function(values) {
			$fromText.text(values[0]);
			$toText.text(values[1]);
		});

		$this.data('slider', slider);
	});

};

exports.init = multislider;



// WEBPACK FOOTER //
// ./src/js/components/multislider.js